
export function seo(data = {}) {
  let baseTitle = "Words of Magic";
  data.title = data.title || '';
  // data.metaDescription = data.metaDescription || '';

  document.title = baseTitle + (data.title ? " - " + data.title : "");
  // document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
}
